/**
 * Design tokens MEL — direção AQUA / CIANO com glassmorphism.
 *
 * Substitui o índigo (#6366F1) e o teal Looka (#3BBAC5) da referência por uma
 * paleta aqua/ciano consistente em web, admin e (Fase 3) mobile.
 *
 * TODO: quando `@mel/ui` (melapp-docs/packages/ui) estiver publicado, importar
 * estes tokens de lá em vez de duplicar. Fonte única evita drift de marca.
 */

export const melColors = {
  // Marca — aqua/ciano
  aqua50: "#ECFEFF",
  aqua100: "#CFFAFE",
  aqua200: "#A5F3FC",
  aqua300: "#67E8F9",
  aqua400: "#22D3EE",
  aqua500: "#06B6D4", // primária
  aqua600: "#0891B2", // hover/pressed
  aqua700: "#0E7490",
  turquoise500: "#2DD4BF", // realce do gradiente
  turquoise600: "#14B8A6",

  // Neutros frios (vidro)
  ink: "#0B2A30", // texto profundo (teal-preto)
  inkSoft: "#3A5A60",
  glassBg: "rgba(255, 255, 255, 0.65)",
  glassBgDark: "rgba(11, 42, 48, 0.55)",
  glassBorder: "rgba(45, 212, 191, 0.28)",

  // Estados (frios)
  success: "#10B981",
  warning: "#F59E0B",
  error: "#EF4444",
  info: "#0EA5E9",
} as const;

/** Gradiente ciano → turquesa usado em header, botões primários e brilho. */
export const melGradient = `linear-gradient(135deg, ${melColors.aqua500} 0%, ${melColors.turquoise500} 100%)`;

/** Sombra/brilho difuso característico do glass. */
export const melGlow = "0 8px 32px rgba(6, 182, 212, 0.18)";

/** Cores funcionais das 5 categorias (colhidas de references/src/index.css). */
export const categoryColors: Record<string, string> = {
  lembrete: "#F97316", // âmbar
  evento: "#0EA5FF", // azul céu
  saude: "#EC4899", // rosa
  tarefa: "#22C55E", // verde
  nota: "#8B5CF6", // violeta
};

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? "MEL Admin";
export const APP_TAGLINE =
  import.meta.env.VITE_APP_TAGLINE ?? "Com você em cada lembrete";
